module.exports = __webpack_public_path__ + "static/naicsgraphs-c4694d44a0e3d31502882e265dff4cec.png";